<div class="message-text">
  <div class="message-text__message-content message-content">
    <ng-content></ng-content>
    <app-web-page *ngIf="webPage" [value]="webPage"></app-web-page>
  </div>
</div>
